module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-temple.3def0d8f.png";